export const getUserType = (
  company: string | undefined,
  isDemo: boolean | undefined,
  isPlanPublic: boolean | undefined
): string => {
  if (company === 'Calyx Global') {
    return 'calyx employee';
  }

  if (isDemo === true) {
    return 'demo';
  }

  if (isPlanPublic === true) {
    return 'public product';
  }

  return 'subscriber';
};
